export default __webpack_public_path__ + "static/media/search-blue.5444a49a.svg";